/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse20012Attempt from './InlineResponse20012Attempt';
import InlineResponse20012Events from './InlineResponse20012Events';
import InlineResponse20012FormativeAction from './InlineResponse20012FormativeAction';

/**
 * The InlineResponse20012Data model module.
 * @module model/InlineResponse20012Data
 * @version 1.0.0
 */
class InlineResponse20012Data {
    /**
     * Constructs a new <code>InlineResponse20012Data</code>.
     * @alias module:model/InlineResponse20012Data
     */
    constructor() { 
        
        InlineResponse20012Data.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20012Data</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012Data} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012Data} The populated <code>InlineResponse20012Data</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012Data();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('has_paid_or_used_attempt')) {
                obj['has_paid_or_used_attempt'] = ApiClient.convertToType(data['has_paid_or_used_attempt'], 'Boolean');
            }
            if (data.hasOwnProperty('is_exception')) {
                obj['is_exception'] = ApiClient.convertToType(data['is_exception'], 'Boolean');
            }
            if (data.hasOwnProperty('attempt')) {
                obj['attempt'] = InlineResponse20012Attempt.constructFromObject(data['attempt']);
            }
            if (data.hasOwnProperty('formative_action')) {
                obj['formative_action'] = InlineResponse20012FormativeAction.constructFromObject(data['formative_action']);
            }
            if (data.hasOwnProperty('events')) {
                obj['events'] = ApiClient.convertToType(data['events'], [InlineResponse20012Events]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
InlineResponse20012Data.prototype['id'] = undefined;

/**
 * @member {String} code
 */
InlineResponse20012Data.prototype['code'] = undefined;

/**
 * @member {String} name
 */
InlineResponse20012Data.prototype['name'] = undefined;

/**
 * @member {Boolean} has_paid_or_used_attempt
 */
InlineResponse20012Data.prototype['has_paid_or_used_attempt'] = undefined;

/**
 * @member {Boolean} is_exception
 */
InlineResponse20012Data.prototype['is_exception'] = undefined;

/**
 * @member {module:model/InlineResponse20012Attempt} attempt
 */
InlineResponse20012Data.prototype['attempt'] = undefined;

/**
 * @member {module:model/InlineResponse20012FormativeAction} formative_action
 */
InlineResponse20012Data.prototype['formative_action'] = undefined;

/**
 * @member {Array.<module:model/InlineResponse20012Events>} events
 */
InlineResponse20012Data.prototype['events'] = undefined;






export default InlineResponse20012Data;

